
import "swiper/css";
import "swiper/css/navigation";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NewRelease from "./NewRelease";
import Trending from './Trending';
import RacingGames from './RacingGames';
import MindMining from './MindMining';
import SolitaireGames from './SolitaireGames';
import PopularGames from './PopularGames';
import PuzzleSkillsGames from './PuzzleSkillsGames';



function ProfileCard() {

    const [profileCount, setProfileCount] = useState(0);
    const [gameCount, setGameCount] = useState(0);
    const [rewardCount, setRewardCount] = useState(0);

    const animateCount = (target, setter, duration = 3000) => {
        const increment = target / (duration / 16);
        let current = 0;

        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                setter(target);
                clearInterval(timer);
            } else {
                setter(Math.floor(current));
            }
        }, 16);
    };

    useEffect(() => {
        animateCount(28328, setProfileCount, 5000);
        animateCount(383, setGameCount, 5000);
        animateCount(2956, setRewardCount, 5000);
    }, []);

    const formatNumber = (num) => {
        return num.toLocaleString();
    };

    const allGames = [
        {
            id: 1,
            title: "Warzone",
            image: "./assets/games-slider1/browse-game-img-1.webp"
        },
        {
            id: 2,
            title: "Redsquad",
            image: "./assets/games-slider1/browse-game-img-2.webp"
        },
        {
            id: 3,
            title: "Cyborg",
            image: "./assets/games-slider1/browse-game-img-3.webp"
        },
        {
            id: 4,
            title: "Headshot",
            image: "./assets/games-slider1/browse-game-img-4.webp"
        },
        {
            id: 5,
            title: "Cyberpunk",
            image: "./assets/games-slider1/browse-game-img-5.webp"
        },

        {
            id: 6,
            title: "Army",
            image: "./assets/games-slider1/browse-game-img-6.webp"
        },
        {
            id: 7,
            title: "Holigans",
            image: "./assets/games-slider1/browse-game-img-7.webp"
        },
        {
            id: 8,
            title: "Anonymous",
            image: "./assets/games-slider1/browse-game-img-8.webp"
        },
       { id: 9, title: "Alphabet Memory", image: "/assets/games-slider1/Alphabet_memory.png" },
       { id: 10, title: "Bubble Shooter", image: "/assets/games-slider1/bubble_shooter.jpg" },
       { id: 11, title: "Iron Snout", image: "/assets/games-slider1/Iron_Snout.png" },
       { id: 12, title: "Lucky Wheels", image: "/assets/games-slider1/lucky_wheels.png" },
       { id: 13, title: "Monkey Mart", image: "/assets/games-slider1/monkey_mart.jpg" },
        {
            id: 14,
            title: "Cyborg",
            image: "./assets/games-slider1/browse-game-img-14.webp"
        }
        ,
        {
            id: 15,
            title: "Head",
            image: "./assets/games-slider1/browse-game-img-15.webp"
        }
        ,
        {
            id: 16,
            title: "Sword Shield",
            image: "./assets/games-slider1/browse-game-img-16.webp"
        }
        ,
        {
            id: 17,
            title: "Head Hunter",
            image: "./assets/games-slider1/browse-game-img-17.webp"
        }
        ,
        {
            id: 18,
            title: "Archer",
            image: "./assets/games-slider1/browse-game-img-18.webp"
        }
        ,
        {
            id: 19,
            title: "Kids Game Mind",
            image: "./assets/games-slider1/kids_game_mind.jpg"
        }
        ,
        {
            id: 20,
            title: "Genius",
            image: "./assets/games-slider1/genius_game.jpg"
        }
        ,
        {
            id: 21,
            title: "Sudoku",
            image: "./assets/games-slider1/sudoko_game.jpg"
        }
        ,
        {
            id: 22,
            title: "Sliding Number",
            image: "./assets/games-slider1/sliding_number.jpg"
        }
        ,
        {
            id: 24,
            title: "Spelling Challange",
            image: "./assets/games-slider1/spellingchllange.jpg"
        },
        {
            id: 25,
            title:"Stick Fruit",
            image: "./assets/games-slider1/one.jpg"
        },
        {
            id: 26,
            title: "Tetrix Mania",
            image: "./assets/games-slider1/two.jpg"
        },
        {
            id: 27,
            title: "Urban Crosser",
            image: "./assets/games-slider1/three.jpg"
        },
        {
            id: 28,
            title: "Water Sort Puzzle",
            image: "./assets/games-slider1/four.jpg"
        },
         {
            id: 29,
            title: "World Puzzle",
            image: "./assets/games-slider1/five.jpg"
        },

    ];

    const trendingGames = allGames.slice(0, 7);
    const newReleaseGames = allGames.slice(8, 14);
    const Racing = allGames.slice(11, 17);
    const Multi = allGames.slice(18, 24);

    const navigate = useNavigate();

    return (
        <>
  <style>{`
    .swiper-button-prev-trending:hover,
    .swiper-button-next-trending:hover,
    .swiper-button-prev-release:hover,
    .swiper-button-next-release:hover,
    .swiper-button-prev-racing:hover,
    .swiper-button-next-racing:hover,
    .swiper-button-prev-multi:hover,
    .swiper-button-next-multi:hover {
      transform: scale(1.05);
    }
    /* ensure images don't overflow on small screens */
    .trending-swiper img { display:block; width:100%; height:auto; }
  `}</style>

  <div className='relative w-full h-full lg:h-full sm:h-full bg-[#212129] py-20'>
    <div className='absolute z-10 top-2 md:-top-16 lg:-top-16 left-1/2 -translate-x-1/2 w-full px-4 '>
      <div className="flex items-center justify-center">
        <div className='flex items-center gap-5 flex-wrap'>
          <div className="card cursor-pointer bg-[#0a0a0a] w-full sm:w-[300px] md:w-[320px] lg:w-[340px] rounded-[12px] h-auto sm:h-[130px] lg:h-[142px] flex items-center px-4 sm:px-6 border border-gray-800 shadow-[0_15px_15px_rgba(96,165,250,0.45)]
 hover:border-yellow-500 transition-all duration-300">
            <div className='flex items-center gap-4'>
              <div className=' p-3 rounded-lg'>
                <img src="./assets/images/icon/counter-icon-1.png" alt="" className="w-10 h-10 sm:w-12 sm:h-12" />
              </div>
              <div>
                <h2 className='text-white text-2xl sm:text-3xl lg:text-4xl font-SemiBold'>{formatNumber(profileCount)}</h2>
                <p className='text-green-500 text-sm font-medium mt-1'>Profiles Created</p>
              </div>
            </div>
          </div>

          <div className="card cursor-pointer bg-[#0a0a0a]  w-full sm:w-[300px] md:w-[320px] lg:w-[340px] rounded-[12px] h-auto sm:h-[130px] lg:h-[142px] flex items-center px-4 sm:px-6 border border-gray-800 shadow-[0_15px_15px_rgba(96,165,250,0.45)]  hover:border-yellow-500 transition-all duration-300">
            <div className='flex items-center gap-4'>
              <div className=' p-3 rounded-lg'>
                <img src="./assets/images/icon/counter-icon-2.png" alt="" className="w-10 h-10 sm:w-12 sm:h-12" />
              </div>
              <div>
                <h3 className='text-white text-2xl sm:text-3xl lg:text-4xl font-SemiBold'>{formatNumber(gameCount)}</h3>
                <p className='text-green-500 text-sm font-medium mt-1'>Game Running</p>
              </div>
            </div>
          </div>

          <div className="card cursor-pointer bg-[#0a0a0a] w-full sm:w-[300px] md:w-[320px] lg:w-[340px] rounded-[12px] h-auto sm:h-[130px] lg:h-[142px] flex items-center px-4 sm:px-6 border border-gray-800 shadow-[0_15px_15px_rgba(96,165,250,0.45)] hover:border-yellow-500 transition-all duration-300">
            <div className='flex items-center gap-4'>
              <div className=' p-3 rounded-lg'>
                <img src="./assets/images/icon/counter-icon-3.png" alt="" className="w-10 h-10 sm:w-12 sm:h-12" />
              </div>
              <div>
                <h3 className='text-white text-2xl sm:text-3xl lg:text-4xl font-SemiBold'>{formatNumber(rewardCount)}</h3>
                <p className='text-green-500 text-sm font-medium mt-1'>Total Engaged</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    {/* TRENDING */}
   <div className="mt-[150px] sm:mt-[50px] md:mt-[0px]">

        
    <Trending/>

    {/* NEW RELEASE */}
     <NewRelease newReleaseGames={newReleaseGames} />


    {/* RACING */}
    <RacingGames/>
    
    {/* MIND-MINING */}
    <MindMining/>

    {/* SOLITAIRE GAMES */}
    <SolitaireGames/>

    {/* POPULAR GAMES */}
    <PopularGames/>

    {/* PUZZLE/SKILLS GAMES */}
    <PuzzleSkillsGames/>
    </div>


  </div>
</>

    )
}

export default ProfileCard;
